"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = exports.VlpTabWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonTabs = require("@mmc/common-tabs");
var _slider = require("./slider");
var _cardRenderer = require("./cards/card-renderer");
var _vlpTableCarousel = _interopRequireDefault(require("./vlp-table-carousel.css"));
// Function to handle tab change events
var tabChange = function tabChange(tabName, nameplate, mksSectionName) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'clickevent',
      section_name: mksSectionName,
      component: 'Carousel',
      action: 'Tab',
      click_text: tabName,
      nameplate: nameplate
    });
  }
};
var _handleChange = function handleChange(clickText, nameplate, mksSectionName) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'clickevent',
      section_name: mksSectionName,
      component: 'Carousel',
      action: 'Slider Dot',
      click_text: clickText,
      nameplate: nameplate
    });
  }
};

// Carousel settings
var carouselSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToScroll: 1,
  variableWidth: true
};

// Function to extract tab name labels from items
var extractTabNameLabels = function extractTabNameLabels(items) {
  if (!items || !Array.isArray(items)) {
    return [];
  }
  return items.map(function (item) {
    return item.tabNameLabel;
  });
};

// Component for tab wrapper
var VlpTabWrapper = function VlpTabWrapper(_ref) {
  var items = _ref.items,
    nameplate = _ref.nameplate,
    setTabName = _ref.setTabName,
    disclaimerData = _ref.disclaimerData,
    mksSectionName = _ref.mksSectionName;
  var tabNames = extractTabNameLabels(items);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].vlpTableCarousel
  }, /*#__PURE__*/_react["default"].createElement(_commonTabs.CommonTabs, {
    tabNames: tabNames,
    variant: "light",
    tabListClasses: _vlpTableCarousel["default"].tabList,
    disclaimerData: disclaimerData,
    onTabChange: function onTabChange(index) {
      setTabName(tabNames[index]);
      tabChange(tabNames[index], nameplate, mksSectionName);
    }
  }, Array.isArray(items) && items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_slider.Slider, {
      key: index,
      settings: carouselSettings,
      handleChange: function handleChange(currentSlide) {
        var clickText = currentSlide + 1 + "/" + item.carousels.length;
        _handleChange(clickText, nameplate, mksSectionName);
      }
    }, Array.isArray(item.carousels) && item.carousels.map(function (carousel, carouselIndex) {
      return /*#__PURE__*/_react["default"].createElement(_cardRenderer.CardRenderer, {
        key: carouselIndex,
        cardType: carousel.carouselType,
        cardProps: carousel[carousel.carouselType],
        disclaimerData: disclaimerData
      });
    }));
  })));
};

// PropTypes validation
exports.VlpTabWrapper = VlpTabWrapper;
// Default props
VlpTabWrapper.defaultProps = {
  items: []
};
var _default = VlpTabWrapper;
exports["default"] = _default;